import router from '@/router'
let token = localStorage.getItem('token')
let whiteList = ['/forget', '/register']
// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})
